import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-dark text-brand-cream py-20 md:py-32 px-6 relative overflow-hidden" data-id="element-112">
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-113">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-brand-gold rounded-full mix-blend-screen filter blur-[128px]" data-id="element-114"></div>
      </div>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-115">
        <FadeIn data-id="element-116">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-brand-cream" data-id="element-117">
            Riqueza Integral: <br data-id="element-118" />
            <span className="text-brand-gold italic font-normal" data-id="element-119">
              El Método de los 4 Cuerpos
            </span>
          </h1>
          <p className="text-lg md:text-xl mb-10 text-brand-cream/80 leading-relaxed font-light" data-id="element-120">
            Consigue tu libertad financiera sin sacrificar tu salud, tu paz
            mental ni tu espíritu en el proceso.
          </p>
          <Button onClick={scrollToOffer} className="w-full md:w-auto" data-id="element-121">
            Quiero mi copia ahora
          </Button>
          <p className="mt-4 text-sm text-brand-cream/60 flex items-center gap-2" data-id="element-122">
            <svg className="w-4 h-4 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-123">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-124" />
            </svg>
            Compra segura. Acceso instantáneo en formato PDF.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} className="relative" data-id="element-125">
          <div className="relative w-full max-w-md mx-auto aspect-square md:aspect-[4/5]" data-id="element-126">
            <div className="absolute inset-0 bg-brand-gold/20 translate-x-4 translate-y-4 rounded-sm" data-id="element-127"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2ojRu2fU14DrBqjBHh5HYT/riqueza_integral.png" alt="Riqueza Integral: El Método de los 4 Cuerpos" className="relative z-10 w-full h-full object-cover rounded-sm shadow-2xl border border-brand-gold/30" data-id="element-128" />
          </div>
        </FadeIn>
      </div>
    </section>;
}